// Packages
import ListItem from 'modules/Suppliers/components/ListItem';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// Other
import './styles.css';

const SupplierList = ({ isLoading, items, onChange, query }) => {

	// Loading State
	if ( isLoading )
	{
		return (
			<div className='SupplierList'>
					<ListItem isLoading={true}/>
			</div>
		)
	}


	// Empty State
	if ( items.length === 0 )
	{
		return (
			<h3 className='opacity italic'>No results</h3>
		)
	}


	// Data State
	return (
		<div className='SupplierList'>

			{items.map((item, index) => {

				return (
						<Link className='SupplierList__link' to={'/suppliers/' + item.id + (query !== '' ? '?query=' + query : '')} key={index}>
							<ListItem 
								{...item} 
								isLoading={false}
								onChange={() => {onChange()}}
							/>
						</Link>
				)
				
			})}

		</div>
	)
}

SupplierList.propTypes = {
	isLoading: PropTypes.bool,
	items: PropTypes.array,
	onChange: PropTypes.func,
	query: PropTypes.string
}

SupplierList.defaultProps = {
	isLoading: false,
	items: [],
	onChange: () => {'onChange is not set!'},
	query: ''
}

export default SupplierList;